export const clearImageTransformations = (url: string): string =>
  url
    .replace(/(\/upload\/)(.*?)(v\d+\/)/, '$1t_image_article_800/$3')
    .replace(/\.jpg(?=($|\?))/i, '.webp')
